import { Button, Card, Col, Form, Input, Row } from 'antd';
import { useForm } from 'antd/es/form/Form';
import axios from 'axios';
import React, { useEffect } from 'react';
import { API_URL } from '../../Constants';

function ValConfig({ initialValues }) {
    let [form] = useForm();
   useEffect(() => {
        form.setFieldsValue({
            value: initialValues?.value
        })
    }, [initialValues]);
    const onFinish = (values) => {
        axios.put(`${API_URL}/configs/kurs`, values)
            .then(res => {
            })
            .catch(err => {
            })
    };

    

    return (
        <Card title="Valuta kursi" hoverable>
            <Form form={form} onFinish={onFinish}>
                <Row>
                    <Col span={20}>
                        <Form.Item label="Valuta kursi" name="value">
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={4}>
                        <Form.Item>
                            <Button type="primary" htmlType="submit">Save</Button>
                        </Form.Item>
                    </Col>
                </Row>

            </Form>

            <Button onClick={()=>{
                axios.get('/convertprice').then(data=>{
                    alert(data.data)
                })
            }} type='primary' style={{backgroundColor: 'green'}}>So'mdagi qiymatni Qayta narxlash</Button>
        </Card>
    );
}

export default ValConfig;